<template>
  <div class="login-container">
    <div class="login-box">
      <h2>RaiseTrack Login</h2>
      <form @submit.prevent="login">
        <div class="form-group">
          <label for="email">Email</label>
          <input v-model="formData.email" type="email" id="email" required />
        </div>

        <div class="form-group">
          <label for="password">Password</label>
          <input
            v-model="formData.password"
            type="password"
            id="password"
            required
          />
        </div>

        <button type="submit">Login</button>
      </form>

      <!-- <p v-if="errorMessage" class="error">{{ errorMessage }}</p> -->
      <p v-if="errorMessage" class="error">
  {{ errorMessage }}
  <span v-if="errorMessage.toLowerCase().includes('not activated')">
    &nbsp;
    <router-link
      to="/activate"
      class="text-blue-600 hover:underline font-medium"
      >Activate Now</router-link
    >
  </span>
  <span v-else-if="errorMessage.toLowerCase().includes('no user')">
    &nbsp;
    <router-link
      to="/signup"
      class="text-blue-600 hover:underline font-medium"
      >Signup</router-link
    >
  </span>
  <span v-else-if="errorMessage.toLowerCase().includes('password')">
    &nbsp;
    <router-link
      to="/forgot/password"
      class="text-blue-600 hover:underline font-medium"
      >Reset password</router-link
    >
  </span>
  
</p>


      <div v-if="!errorMessage" class="text-center mt-4 text-sm text-gray-500">
        Don’t have an account yet?
        <router-link
          to="/signup"
          class="text-blue-600 hover:underline font-medium"
          >Sign up</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoginPage",
  data() {
    return {
      formData: {
        email: "",
        password: "",
      },
      errorMessage: "",
      message: "",
    };
  },
  methods: {
    async login() {
      try {
        const response = await axios.post(
          "https://api.roberms.com/fundraise/login",
          this.formData
        );

        console.log(response.data); // Check the entire response

        // Check if the response contains a token
        if (response.data.token) {
          // Successful login, save token to localStorage
          localStorage.setItem("user", JSON.stringify(response.data.user));
          localStorage.setItem("token", response.data.token); // Store the token
          this.$router.push("/dashboard"); // Redirect to dashboard
        } else {
          // If no token in the response, show the error
          this.errorMessage = "Invalid username or password";
          console.error(this.errorMessage); // Log the error
        }
      } catch (err) {
        // Handle any API errors
        console.error("Login failed:", err);
        this.errorMessage =
          err.response.data.message || "Something went wrong.";
      }
    },
    async loginUser() {
      try {
        const response = await axios.post(
          "https://api.roberms.com/fundraise/login",
          this.formData
        );
        console.log(response.data);

        if (response.data.status === "success") {
          // If login is successful, save the user data in localStorage and navigate to the dashboard
          localStorage.setItem("user", JSON.stringify(response.data.user));
          this.$router.push("/dashboard");
        } else {
          // If login failed (e.g., wrong password), show an error message
          this.errorMessage =
            response.data.message || "Invalid email or password";
          console.error(this.errorMessage); // Optionally log this error
        }
      } catch (error) {
        this.errorMessage = "Invalid credentials. Please try again.";
        console.error("Login error:", error);
      }
    },
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f5f5f5;
}
.login-box {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 350px;
}
h2 {
  text-align: center;
  margin-bottom: 1.5rem;
}
.form-group {
  margin-bottom: 1rem;
}
label {
  display: block;
  margin-bottom: 0.3rem;
}
input {
  width: 100%;
  padding: 0.6rem;
  border-radius: 5px;
  border: 1px solid #ccc;
}
button {
  width: 100%;
  padding: 0.7rem;
  background: #007bff;
  border: none;
  color: white;
  border-radius: 5px;
  font-weight: bold;
  cursor: pointer;
}
button:hover {
  background: #0056b3;
}
.error {
  color: red;
  text-align: center;
  margin-top: 1rem;
}
</style>
